module.exports = __webpack_public_path__ + "static/why_3-d673f1210fa02f211d8287f1ed89c4c0.gif";